module.exports = __webpack_public_path__ + "img/house8.e096c128.jpg";